import React, { useEffect } from "react";
import LOGO from "../../assets/images/logos/logo.png";
import moment from "moment";

const PolicyScheduleDoc = ({ data, policy_document_risk }) => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div>
      <div className='d-flex flex-column justify-content-center align-items-center'>
        <img src={LOGO} alt='logo' width={100} />
        <h4
          className='text-uppercase text-primary fw-bold'
          style={{ fontSize: "30px", color: "#2e3192" }}
        >
          PRUDENT CHOICE MICROINSURANCE
        </h4>
      </div>
      <div
        className='row'
        style={{ marginInlineStart: "0px", marginInlineEnd: "0px" }}
      >
        <div
          className='d-flex justify-content-center align-items-center h-50'
          style={{ backgroundColor: "#727CF5" }}
        >
          <h5
            className='text-uppercase text-white fw-bold font-22'
            style={{ fontSize: "35px" }}
          >
            POLICY SCHEDULE
          </h5>
        </div>
      </div>
      <table class='table scheduled table-bordered'>
        <thead></thead>
        <tbody>
          <tr>
            <td>POLICY NO</td>
            <td>{data?.policyAppNumber}</td>
          </tr>
          <tr>
            <td>INSURED</td>
            <td>{data?.customerFirstName + " " + data?.customerLastName}</td>
          </tr>
          <tr>
            <td>ADDRESS</td>
            <td>{data?.homeAddress}</td>
          </tr>
          <tr>
            <td>OCCUPATION</td>
            <td>{data?.occupation}</td>
          </tr>
          <tr>
            <td>TYPE OF POLICY</td>
            <td>Cover</td>
          </tr>
          <tr>
            <td>RISK COVERED</td>
            <td>
              {policy_document_risk?.map((item, i) => (
                <p key={i}>
                  {i + 1}.{" "}
                  <span
                    className={`me-1 ${item?.description ? "fw-bold" : ""}`}
                  >
                    {item?.coverFor}
                    {item?.description ? ":" : ""}
                  </span>
                  {item?.description}
                </p>
              ))}
            </td>
          </tr>
          <tr>
            <td>ANNUAL PREMIUM</td>
            <td>&#x20A6;{parseFloat(data?.totalPremium).toFixed(2)}</td>
          </tr>
          <tr>
            <td>PAYMENT FREQUENCY</td>
            <td>{data?.repayment_frequency}</td>
          </tr>
          <tr>
            <td>RATE</td>
            <td>
              {policy_document_risk?.length && policy_document_risk[0]?.rate}%
            </td>
          </tr>
          <tr>
            <td>EFFECTIVE DATE</td>
            <td>{moment(data?.effectiveDate).format("D-M-Y")}</td>
          </tr>
          <tr>
            <td>RENEWAL DATE</td>
            <td>{moment(data?.endDate).format("D-M-Y")}</td>
          </tr>
          <tr>
            <td>LOADING/DISCOUNT</td>
            <td>{data?.discount ? data?.discount : "Nil"}</td>
          </tr>
          <tr>
            <td>AGENT</td>
            <td>{data?.agentFirstName + " " + data?.agentLastName}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default PolicyScheduleDoc;
